var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#3A559F;}\n\t.st2{fill:#F4F4F4;}\n\t.st3{fill:#FF0084;}\n\t.st4{fill:#0063DB;}\n\t.st5{fill:#00ACED;}\n\t.st6{fill:#FFEC06;}\n\t.st7{fill:#FF0000;}\n\t.st8{fill:#25D366;}\n\t.st9{fill:#0088FF;}\n\t.st10{fill:#314358;}\n\t.st11{fill:#EE6996;}\n\t.st12{fill:#01AEF3;}\n\t.st13{fill:#FFFEFF;}\n\t.st14{fill:#F06A35;}\n\t.st15{fill:#00ADEF;}\n\t.st16{fill:#1769FF;}\n\t.st17{fill:#1AB7EA;}\n\t.st18{fill:#6001D1;}\n\t.st19{fill:#E41214;}\n\t.st20{fill:#05CE78;}\n\t.st21{fill:#7B519C;}\n\t.st22{fill:#FF4500;}\n\t.st23{fill:#00F076;}\n\t.st24{fill:#FFC900;}\n\t.st25{fill:#00D6FF;}\n\t.st26{fill:#FF3A44;}\n\t.st27{fill:#FF6A36;}\n\t.st28{fill:#0061FE;}\n\t.st29{fill:#F7981C;}\n\t.st30{fill:#EE1B22;}\n\t.st31{fill:#EF3561;}\n\t.st32{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st33{fill:#0097D3;}\n\t.st34{fill:#01308A;}\n\t.st35{fill:#019CDE;}\n\t.st36{fill:#FFD049;}\n\t.st37{fill:#16A05D;}\n\t.st38{fill:#4486F4;}\n\t.st39{fill:none;}\n\t.st40{fill:#34A853;}\n\t.st41{fill:#4285F4;}\n\t.st42{fill:#FBBC05;}\n\t.st43{fill:#EA4335;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M17,14.5l4.2-4.5L4.9,1.2C4.8,1.1,4.6,1.1,4.3,1L17,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M23,21l5.9-3.2c0.7-0.4,1.1-1,1.1-1.8s-0.4-1.5-1.1-1.8L23,11l-4.7,5L23,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M2.4,1.9C2.1,2.2,2,2.6,2,3V29c0,0.4,0.1,0.8,0.4,1.2L15.6,16L2.4,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M17,17.5L4.3,31c0.2,0,0.4-0.1,0.6-0.2L21.2,22L17,17.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo (6).0ea710cb5546de304bb9cefeeac6f65b.svg";
export { ForwardRef as ReactComponent };